module.exports = __webpack_public_path__ + "img/_K8A7963.d56f3cf9.jpeg";